import styles from "../landing-page-mobile-one.module.css";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useAnalyticsTracker } from "analytics-tracker";

interface CTASectionMobileProps {
  onClickCTA: () => void;
}

export const CTASectionMobile = (props: CTASectionMobileProps) => {
  const { trackEvent } = useAnalyticsTracker();

  const handleClick = () => {
    trackEvent("Mobile landing CTA clicked", { section: "cta", button: "browse_designs" });
    props.onClickCTA();
  };

  return (
    <section className={styles.ctaSectionMobile}>
      <p className={styles.ctaSubtitleMobile}>
        Create your custom art print in minutes
      </p>
      <CTAButton title="BROWSE DESIGNS" onClick={handleClick} />
    </section>
  );
};
